export type BrandWizardProgressEntry = {
  lastStepId?: string;
  completed?: boolean;
  completedAt?: number;
};

export type BrandWizardStepId =
  | "brand-basics"
  | "brand-details"
  | "quote-experience"
  | "trustpilot"
  | "domains-email"
  | "stripe-brand"
  | "email-templates"
  | "brand-summary";

const BRAND_WIZARD_STEP_IDS: BrandWizardStepId[] = [
  "brand-basics",
  "brand-details",
  "quote-experience",
  "trustpilot",
  "domains-email",
  "stripe-brand",
  "email-templates",
  "brand-summary",
];

export function parseBrandResumeStep(
  stepId?: string,
  stripeConnected = false
): BrandWizardStepId {
  if (!stepId) return "brand-basics";
  if (stepId === "stripe-brand" && !stripeConnected) {
    return "email-templates";
  }
  if (BRAND_WIZARD_STEP_IDS.includes(stepId as BrandWizardStepId)) {
    return stepId as BrandWizardStepId;
  }
  return "brand-basics";
}

export function isBrandWizardComplete(
  brandId: string,
  brandsOnboardingCompleted?: string[],
  brandWizardProgress?: Record<string, BrandWizardProgressEntry>
): boolean {
  if (brandsOnboardingCompleted?.includes(brandId)) return true;
  return brandWizardProgress?.[brandId]?.completed === true;
}

export function buildBrandWizardSteps(stripeConnected: boolean) {
  const steps: Array<{ id: BrandWizardStepId; label: string }> = [
    { id: "brand-basics", label: "Basics" },
    { id: "brand-details", label: "Legal" },
    { id: "quote-experience", label: "Quotes" },
    { id: "trustpilot", label: "Reviews" },
    { id: "domains-email", label: "Domains" },
  ];
  if (stripeConnected) {
    steps.push({ id: "stripe-brand", label: "Stripe" });
  }
  steps.push(
    { id: "email-templates", label: "Emails" },
    { id: "brand-summary", label: "Summary" }
  );
  return steps;
}

export function getNextBrandWizardStepId(
  currentStepId: BrandWizardStepId,
  stripeConnected: boolean
): BrandWizardStepId | null {
  const steps = buildBrandWizardSteps(stripeConnected);
  const index = steps.findIndex((step) => step.id === currentStepId);
  return steps[index + 1]?.id ?? null;
}
